export const HEADER = "KYC Declaration";
export const I_ACCEPT_TEXT = "I ACCEPT";
